export default function setPopup ({ props, state }) {
  state.set('yoyth.popup', {...props})
};
